<div class="container-fluid">
  <div class="row">
    <div class="col-md-2">
      <div class="user-avatar"
           tooltipPosition="bottom"
           pTooltip="Maximum allowed size is 5mb."
           (click)="inputUpload.click()"
      >
        <div class="user-avatar__image">
          <p-avatar
            shape="circle"
            size="xlarge"
            [image]="(user$ | async).avatar"
          ></p-avatar>
        </div>
        <div class="user-avatar__upload">
          <label>Edit</label>
          <input #inputUpload
                 type="file"
                 (change)="fileChangeEvent($event)"
          />
        </div>
      </div>
    </div>

    <div class="col-md-10">
      <app-form-constructor
        [formConfig]="personalInfoFormConfig"
        (changeFieldEvent)="updateUser($event)"
      ></app-form-constructor>
    </div>

    <div class="col-12">
      <ng-container *ngIf="contactInfoFormConfig.length">
        <div class="pl-3 mb-4 mt-5">
          <h4>Contact information</h4>
        </div>
        <app-form-constructor
          [formConfig]="contactInfoFormConfig"
          (changeFieldEvent)="updateUser($event)"
        ></app-form-constructor>
      </ng-container>
    </div>
  </div>
</div>





